var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-item',{attrs:{"title":_vm.caption,"data-source":_vm.dataSource,"breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.loaded)?_c('product-class-editor',{attrs:{"product-class-param-group-data-source":_vm.productClassParamGroupDataSource}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }